import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useModal, useResource, useStore, useToast, usePage } from "@/comn/hooks";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import {
    BASE,
    URLS,
    APIS,
    SG_DRD_CTRA_LIST,
    SG_DRD_CTRA_HIST_LIST,
} from "@/tra/tancis/ptli/sysm/drdctra/services/PtliDrdCtraService";

/*
 * Region Code Management List
 * !== 지역 코드 관리 목록 ==!
 */
export const PTLI0406001S = (props: any) => {
    useResource({
        defaultSchema: [{ area: "cntyCd" }, { area: "comnCd", comnCd: "COM0033" }],
    });

    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0001", "auth_ptli0015", "auth_ptlianyADM"],
    }); 
    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();

    const grid = {
        drdCtraList: useGrid({
            defaultSchema: SG_DRD_CTRA_LIST,
        }),

        drdCtraHistList: useGrid({
            defaultSchema: SG_DRD_CTRA_HIST_LIST,
        }),
    };

    const fetch = {
        // Retrieve a list of Drd Criteria Management Infomaion. !== DRD기준관리 정보 목록을 조회한다.==!
        getDrdCtraList: useFetch({
            api: (page = grid.drdCtraList.page) =>
                APIS.getDrdCtraList(),
            // enabled: comnUtils.isEmpty(form.regnCdSrch.errors),
            key: [grid.drdCtraList.page, grid.drdCtraList.size],
            onSuccess: () => {
                setStore(pgeUid);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),


        // Retrieve a list of Drd Criteria History. !== DRD 이력 목록을 조회한다.==!
        getDrdCtraHistList: useFetch({
            api: (page = grid.drdCtraList.page) =>
                APIS.getDrdCtraHistList(),
            // enabled: comnUtils.isEmpty(form.regnCdSrch.errors),
            key: [grid.drdCtraHistList.page, grid.drdCtraHistList.size],
            onSuccess: () => {
                setStore(pgeUid);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),

        insertDrdCrtaHist : useFetch({
            api: (info: any) => APIS.insertDrdCrta(info),
            enabled: false,
            onSuccess: () => {
                modal.openModal({ content: "msg.com.00059" }); // Successfully updated. !== 정상적으로 수정되었습니다.==!
                
                fetch.getDrdCtraList.fetch(0);
                fetch.getDrdCtraHistList.fetch(0);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00022" }), // Failed to update. !== 수정이 실패하였습니다.==!
        }),
    };

    const render = {
        cell: {
            
        },
    };

    const handler = {
        getDrdCtraList: () => {
            fetch.getDrdCtraList.fetch(0);
        },
        getDrdCtraHistList: () => {
            fetch.getDrdCtraHistList.fetch(0);
        },

        
        onUpdateBtnClick: () => {
            
            const drdCtraList = grid.drdCtraList.getData();
            const originList = grid.drdCtraList.getOrigin();
            
            if(drdCtraList[0].comnPrmtValCn === originList[0].comnPrmtValCn && drdCtraList[1].comnPrmtValCn === originList[1].comnPrmtValCn && drdCtraList[2].comnPrmtValCn === originList[2].comnPrmtValCn ){
                return false;
            }


            const saveObj = {
                dclrHndvCndtVal   : drdCtraList[0].comnPrmtValCn,
                dclrNoSettVal     : drdCtraList[1].comnPrmtValCn,
                dclrPridSettVal   : drdCtraList[2].comnPrmtValCn
            }
            modal.openModal({
                content: "msg.com.00050", // Confirm update? !== 수정하시겠습니까? ==!
                onConfirm: () => fetch.insertDrdCrtaHist.fetch(saveObj),
            });
        },
    };

    useEffect(() => {
        handler.getDrdCtraList();
        handler.getDrdCtraHistList();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid {...grid.drdCtraList.grid} data={fetch.getDrdCtraList.data?.drdCtraList} render={render} />
                    </Group.Section>
                    <Group.Section>
                        <Layout>
                            <Layout.Right>
                              <Layout.Button role={"edit"} onClick={handler.onUpdateBtnClick} />
                            </Layout.Right>
                        </Layout>
                    </Group.Section>
                </Group.Body>
                
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid {...grid.drdCtraHistList.grid} data={fetch.getDrdCtraHistList.data?.drdCtraHistList} render={render} />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
